/* This is generated code, don't alter */
var IfcInternalOrExternalEnum;
(function (IfcInternalOrExternalEnum) {
    IfcInternalOrExternalEnum[IfcInternalOrExternalEnum["INTERNAL"] = 0] = "INTERNAL";
    IfcInternalOrExternalEnum[IfcInternalOrExternalEnum["EXTERNAL"] = 1] = "EXTERNAL";
    IfcInternalOrExternalEnum[IfcInternalOrExternalEnum["EXTERNAL_EARTH"] = 2] = "EXTERNAL_EARTH";
    IfcInternalOrExternalEnum[IfcInternalOrExternalEnum["EXTERNAL_WATER"] = 3] = "EXTERNAL_WATER";
    IfcInternalOrExternalEnum[IfcInternalOrExternalEnum["EXTERNAL_FIRE"] = 4] = "EXTERNAL_FIRE";
    IfcInternalOrExternalEnum[IfcInternalOrExternalEnum["NOTDEFINED"] = 5] = "NOTDEFINED";
})(IfcInternalOrExternalEnum || (IfcInternalOrExternalEnum = {}));
const IfcInternalOrExternalEnumCount = 6;
export { IfcInternalOrExternalEnum, IfcInternalOrExternalEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcInternalOrExternalEnum = new Int32Array([107]);
let prefixSumAddressIfcInternalOrExternalEnum = new Uint32Array([0, 16, 28, 38, 54, 64, 79]);
let slotMapIfcInternalOrExternalEnum = new Int32Array([3, 5, 1, 2, 0, 4]);
let encodedDataIfcInternalOrExternalEnum = (new TextEncoder()).encode(".EXTERNAL_WATER..NOTDEFINED..EXTERNAL..EXTERNAL_EARTH..INTERNAL..EXTERNAL_FIRE.");
let IfcInternalOrExternalEnumSearch = new MinimalPerfectHash(gMapIfcInternalOrExternalEnum, prefixSumAddressIfcInternalOrExternalEnum, slotMapIfcInternalOrExternalEnum, encodedDataIfcInternalOrExternalEnum);
export { IfcInternalOrExternalEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcInternalOrExternalEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcInternalOrExternalEnumSearch, input, cursor, endCursor);
}
